export enum TypeFilterEnum {
  Binary = "binary",
  MultiOutcome = "multi-outcome",
  Breaking = "breaking",
  Trending = "trending",
  UMADisputed = "uma-disputed",
  Aggregated = "aggregated",
}
